<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">
          {{ $t('department.division') }} <span class="text-danger">*</span>
        </label>
        <ts-search-select
          v-model.number="model.division_id"
          :options="divisionOptions"
        ></ts-search-select>
        <div style="color:#cc4946;margin:4px 0 0">
          {{ errors.first('division_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('department.code') }} <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.department_code"
          type="text"
          class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('department_code') }"
          :placeholder="$t('department.enterdepartmentcode')"
        />
        <div class="invalid-feedback" v-if="errors.has('department_code')">
          {{ errors.first('department_code') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('department.nameKh') }} </label>
        <input
          v-model="model.department_name_kh"
          type="text"
          class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('department_name_kh') }"
          :placeholder="$t('department.enterNameKh')"
        />
        <div class="invalid-feedback" v-if="errors.has('department_name_kh')">
          {{ errors.first('department_name_kh') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('department.nameEn') }} <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.department_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('department_name_en') }"
          :placeholder="$t('department.enternameEn')"
        />
        <div class="invalid-feedback" v-if="errors.has('department_name_en')">
          {{ errors.first('department_name_en') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'department-create-form',
  props: ['edit', 'leave'],
  data() {
    return {
      model: {
        division_id: '',
        department_code: '',
        department_name_kh: '',
        department_name_en: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  created() {
    this.setEdit()
  },
  computed: {
    divisionOptions() {
      return this.$store.state.department.divisions.map(el => ({
        value: el.division_id,
        text: el.division_name_en
      }))
    }
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'department' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'department/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'department/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'department' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      ;(this.model.division_id = ''),
        (this.model.department_code = ''),
        (this.model.department_name_kh = ''),
        (this.model.department_name_en = '')
    }
  },
  watch: {
    leave: {
      handler() {
        if (this.leave) {
          this.clearForm()
          this.editing = false
        }
      }
    },
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
